module.exports = __webpack_public_path__ + "img/Demon_03_update.ef1540d7.png";